<!--
 * @Description: input 去掉前后空格、状态有 【，】
 view:true,false =>true:详情 false:不受控制
-->
<template>
  <div class="cos-form-item-detail" v-if="attrs.mode === 'multiple'">
    <div class="multiple-select">
      <template v-if="valuePage && valuePage.length">
        <p v-for="(item, index) in valuePage" :key="index">{{ item }}；</p>
      </template>
      <p v-else>--</p>
    </div>
  </div>
  <div class="cos-form-item-detail cos-form-item-input-detail" v-else>
    <p class="input" :title="valuePage">{{ valuePage }}</p>
  </div>
</template>
<script lang="ts" setup>
import { computed, useAttrs } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const attrs = useAttrs()
const props = defineProps({
  value: {
    type: [String, Number, Array]
  },
  cosDes: {
    type: [String, Number]
  },
  cosBeforeDes: {
    type: [String, Number]
  },
  options: {
    type: Array
  }
})
const valuePage = computed(() => {
  // 是否有options
  const fieldNames: any = attrs.fieldNames
  const options: any = props.options
  const { mode } = attrs
  const labelKey = fieldNames && fieldNames.label ? fieldNames.label : 'label'
  const valKey = fieldNames && fieldNames.value ? fieldNames.value : 'value'
  if (options) {
    if (mode === 'multiple') {
      const resultLabel: any = []
      if (props.value && Array.isArray(props.value)) {
        props.value.forEach((item) => {
          const findv = options.find((v: any) => v[valKey] === item)
          if (findv) {
            if (findv.lang) {
              resultLabel.push(t(findv.lang))
            } else {
              resultLabel.push(findv[labelKey])
            }
          } else {
            resultLabel.push(item)
          }
        })
      }
      return resultLabel
    } else {
      const findv = options.find((item: any) => item[valKey] === props.value)
      let txt = props.value || ''
      if (findv) {
        txt = findv.lang ? t(findv.lang) : findv[labelKey]
      }
      if (props.cosBeforeDes || props.cosDes === 0) {
        txt = props.cosBeforeDes + ' ' + txt
      }
      if (props.cosDes || props.cosDes === 0) {
        if (txt) {
          txt += ` - ${props.cosDes}`
        } else {
          txt = props.cosDes
        }
      }
      if (txt == null || txt === '') {
        txt = '--'
      }
      return txt
    }
  }
  return props.value
})
</script>
<script lang="ts">
export default { name: 'CosSelectView' }
</script>
<style scoped>
.multiple-select p {
  display: inline-block;
  height: 18px;
  line-height: 18px;
  margin-top: 6px;
  margin-bottom: 6px;
}
</style>
